import { PluginContainerData_Alignment, PluginContainerData_Width_Type } from "./../ricos-schema/legacy/wix/rich_content/v1";
const DEFAULTS = Object.freeze({
  config: {
    size: "content",
    alignment: "center"
  }
});
const RICOS_DEFAULTS = Object.freeze({
  containerData: {
    width: {
      size: PluginContainerData_Width_Type.CONTENT
    },
    alignment: PluginContainerData_Alignment.CENTER,
    textWrap: true
  }
});
export {
  DEFAULTS,
  RICOS_DEFAULTS
};
//# sourceMappingURL=defaults.js.map
